class AddOnProducts extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.sliderEnabled === "true") {
      this.initSlideshowSlick();
    }
  }

  initSlideshowSlick() {
    const slideshow = this.querySelector(".slideshow");

    const prev_arrow = this.querySelector(".slick-prev-custom");
    const next_arrow = this.querySelector(".slick-next-custom");

    const slick_options = {
      dots: this.dataset.dots === "true",
      arrows: this.dataset.arrows === "true",
      prevArrow: prev_arrow,
      nextArrow: next_arrow,
      infinite: this.dataset.infinite === "true",
      slidesToShow: parseInt(this.dataset.slidesToShow || 1),
      slidesToScroll: parseInt(this.dataset.slidesToScroll || 1),
      autoplay: this.dataset.autoplay === "true",
      autoplaySpeed: parseInt(this.dataset.speed || 3000),
      responsive: [
        {
          breakpoint: 1190,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    if (slideshow && !$(slideshow).hasClass("slick-initialized")) {
      $(slideshow).slick(slick_options);
    }
  }
}

customElements.define("add-on-products", AddOnProducts);
